// extracted by mini-css-extract-plugin
export default {"content":"OnboardingPage_content__i134p","headline":"OnboardingPage_headline__Agdrl"};